import { isIdXboxGameInformationConfigurationsFormValid } from "../../../../helpers/formValidation";
import { GameInformationConfigurationsDataType, SubFormsDataTypes } from "../../../../models/forms";
import { DataFilterResult, IDataFilter } from "../dataFilter";

export const ConfigurationsDataFilter: IDataFilter = {
  validate: async (data: SubFormsDataTypes | undefined): Promise<DataFilterResult> => {
    const configurationsData = data as GameInformationConfigurationsDataType;
    if (!configurationsData) {
      return { result: true };
    }

    const validSchema = await isIdXboxGameInformationConfigurationsFormValid(configurationsData);
    return { result: validSchema };
  },
};
